import { motion } from "framer-motion";
import { CheckCircle, Inbox, Loader2, Sparkles } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { useStateCardContext } from "./StateCardContext";
import type { StateCardIconProps, StateCardVariant } from "./types";

const defaultIcons: Record<StateCardVariant, LucideIcon> = {
  empty: Inbox,
  loading: Loader2,
  ai: Sparkles,
  success: CheckCircle,
};

const iconColors: Record<StateCardVariant, string> = {
  empty: "text-secondary",
  loading: "text-secondary",
  ai: "text-accent",
  success: "text-accent",
};

export function StateCardIcon({ icon, className }: StateCardIconProps) {
  const { variant } = useStateCardContext();
  const Icon = icon ?? defaultIcons[variant];
  const colorClass = iconColors[variant];

  if (variant === "loading") {
    return (
      <Icon
        size={32}
        className={`animate-spin ${colorClass} ${className ?? ""}`}
      />
    );
  }

  if (variant === "ai") {
    return (
      <motion.div
        animate={{ opacity: [0.5, 1, 0.5] }}
        transition={{
          duration: 2,
          repeat: Number.POSITIVE_INFINITY,
          ease: "easeInOut",
        }}
      >
        <Icon size={32} className={`${colorClass} ${className ?? ""}`} />
      </motion.div>
    );
  }

  if (variant === "success") {
    return (
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      >
        <Icon size={32} className={`${colorClass} ${className ?? ""}`} />
      </motion.div>
    );
  }

  // empty — static
  return <Icon size={32} className={`${colorClass} ${className ?? ""}`} />;
}
